import React from 'react';
import styled from 'styled-components';

import { FlexContainer } from '../../../../../../../../shared/Typhography';

const Container = styled(FlexContainer)`
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
`;

interface ItemContainerProps {
  children: any;
}

const ItemContainer = ({ children }: ItemContainerProps) => (
  <Container
    flexDirection="column"
    alignItems="center"
    justifyContent="space-between"
    padding="20px"
    minHeight="280px"
    width="270px"
  >
    {children}
  </Container>
);

export { ItemContainer };
